<template>
  <div class="nav-menu nav-menu-products">
    <div class="nav-menu-inner app-basic-layout-wrapper">
      <div class="main-wrapper">
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-pingtai"></i>
            <h3 class="group-title">平台</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="https://tui.weibo.com/platform/dmp"
                  target="_blank"
                  @click="doStat('top_nav_dmp')"
                >
                  广告数据管理平台(DMP)
                </a>
              </li>
              <li>
                <a
                  href="https://tui.weibo.com/platform/wax"
                  target="_blank"
                  @click="doStat('top_nav_wax')"
                >
                  程序化广告交易平台(WAX)
                </a>
              </li>
              <li>
                <a
                  href="https://open.weibo.com/"
                  target="_blank"
                  @click="doStat('top_nav_open')"
                >
                  微博开放平台
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-chanpin"></i>
            <h3 class="group-title">产品</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="https://tui.weibo.com/product/search/1"
                  target="_blank"
                  @click="doStat('top_nav_product')"
                >
                  广告产品
                </a>
              </li>
              <li>
                <a
                  href="https://weirenwu.weibo.com"
                  target="_blank"
                  @click="doStat('top_nav_kol')"
                >
                  达人推广
                </a>
              </li>
              <li>
                <a
                  href="https://weibo.com/u/5574029246"
                  target="_blank"
                  @click="doStat('top_nav_store')"
                >
                  微博电商
                </a>
              </li>
              <li>
                <a
                  href="https://verified.weibo.com/verify"
                  target="_blank"
                  @click="doStat('top_nav_verify')"
                >
                  官V认证
                </a>
              </li>
              <li>
                <a
                  href="/brand"
                  title="new"
                  target="_self"
                  @click="doStat('top_nav_brand')"
                >
                  品牌号
                </a>
              </li>
              <li>
                <a
                  href="/topfans"
                  title="new"
                  target="_self"
                  @click="doStat('top_nav_fans')"
                >
                  粉丝头条
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-gongju"></i>
            <h3 class="group-title">工具</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="https://www.yqt365.com/"
                  target="_blank"
                  @click="doStat('top_nav_yqt')"
                >
                  舆情通
                </a>
              </li>
              <li>
                <a
                  href="https://data.weibo.com/index"
                  target="_blank"
                  @click="doStat('top_nav_wzs')"
                >
                  微指数
                </a>
              </li>
              <li>
                <a
                  href="https://www.wrd.cn/login.shtml"
                  target="_blank"
                  @click="doStat('top_nav_wrd')"
                >
                  微热点
                </a>
              </li>
              <li>
                <a
                  href="https://jian.weibo.com/"
                  target="_blank"
                  @click="doStat('top_nav_jian')"
                >
                  微博云剪
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="extra-wrapper nav-group">
        <div class="group-header">
          <i class="iconfont icon-jingxuan"></i>
          <h3 class="group-title">精选内容</h3>
        </div>
        <div class="group-body">
          <a
            href="/brand"
            class="extra-item"
            target="_blank"
            @click="doStat('top_nav_banner_product')"
          >
            <div class="poster">
              <img
                src="https://static.hd.weibo.com/marketing/static/img/353e9258-e160-4ea2-9aaa-298c40207e88.jpg"
                alt=""
              />
            </div>
            <h4>微博品牌营销工具，从公域传播到私域聚合营销升级</h4>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    doStat(module) {
      if (module) {
        this.$stat({
          key: 'nav_click',
          params: { module },
          pathName: this.$route.name
        })
      }
    }
  }
}
</script>
